export const DEFAULT_AUTH_FORM_CLASSES = {
  INPUT_WRAPPER: 'flex-auto text-base font-normal text-text-tertiary 2xl:text-lg',
  INPUT: 'text-text-primary border-input',
  CHECKBOX: 'max-md:gap-1.5',
  CHECKBOX_LABEL: 'text-text-tertiary text-base 2xl:text-lg',
  CHECKBOX_ICON: 'rounded-sm border-2 border-input',
  BUTTON: 'rounded-md font-semibold text-base py-3.5 2xl:text-lg',
  FOOTER_HELP_TEXT_BASE: 'text-center text-base 2xl:text-lg',
} as const
